export enum DeviceSize {
  'desktop' = 'Desktop',
  'tablet' = 'Tablet',
  'mobile' = 'Mobile'
}
